<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 公司详情 -->
        <div class="gsdetails">
            <!-- 公司详情banner -->
            <div class="gsdetails_banner">
                <div class="gsdetails_banner_m column">
                    <div class="gsdetails_banner_m_top row">
                        <div class="gsdetails_banner_m_top_l row">
                            <img src="@/assets/images/qiyelogo2.jpg" class="gsdetails_banner_m_top_l_l">
                            <div class="gsdetails_banner_m_top_l_r column">
                                <h1 class="gsdetails_banner_m_top_l_r_top">
                                    京东集团
                                </h1>
                                <div class="gsdetails_banner_m_top_l_r_bottom row">
                                    <div class="gsdetails_banner_m_top_l_r_bottom_m">已上市&nbsp;·&nbsp;</div>
                                    <div class="gsdetails_banner_m_top_l_r_bottom_m">10000人以上&nbsp;·&nbsp;</div>
                                    <div class="gsdetails_banner_m_top_l_r_bottom_m">电子商务</div>
                                </div>
                            </div>
                        </div>
                        <div class="gsdetails_banner_m_top_r row">
                            <div class="gsdetails_banner_m_top_r_weight">2353</div>
                            <div class="gsdetails_banner_m_top_r_text" style="margin-right: 40px;">在招职位</div>
                            <div class="gsdetails_banner_m_top_r_weight">2353</div>
                            <div class="gsdetails_banner_m_top_r_text">位BOSS</div>
                        </div>
                    </div>
                    <div class="gsdetails_banner_m_bottom row">
                        <div class="gsdetails_banner_m_bottom_l row">
                            <div class="gsdetails_banner_m_bottom_l_m">专精特新企业</div>
                            <div class="gsdetails_banner_m_bottom_l_m">瞪羚企业</div>
                            <div class="gsdetails_banner_m_bottom_l_m">高新技术企业</div>
                        </div>
                        <div class="gsdetails_banner_m_bottom_r row">
                            <div class="gsdetails_banner_m_bottom_r_m row">
                                <i class="el-icon-tickets gsdetails_banner_m_bottom_r_m_i"></i>
                                <div class="gsdetails_banner_m_bottom_r_m_text">完善在线简历</div>
                            </div>
                            <div class="gsdetails_banner_m_bottom_r_m row">
                                <i class="el-icon-paperclip gsdetails_banner_m_bottom_r_m_i"></i>
                                <div class="gsdetails_banner_m_bottom_r_m_text">新增附件简历</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- 公司详情banner end -->
            <!-- 公司详情顶部 -->
            <div class="gsdetails_top row">
                <div :class="gongsitabs == 1 ? 'gsdetails_top_tabs gsdetails_top_tabs_border' : 'gsdetails_top_tabs'"
                    @click="clickTabs(1)">公司简介</div>
                <div :class="gongsitabs == 2 ? 'gsdetails_top_tabs gsdetails_top_tabs_border' : 'gsdetails_top_tabs'"
                    @click="clickTabs(2)">招聘职位(9999)</div>
            </div>
            <!-- 公司详情顶部 end -->
            <div v-if="gongsitabs == 1">
                <!-- 公司详情热招 -->
                <!-- <div class="gsdetails_hotjob">
                    <div class="gsdetails_hotjob_m">
                        <img src="@/assets/images/gongsixiangqingrezhao.png" alt="" style="width: 100%;">
                    </div>
                </div> -->
                <!-- 公司详情热招 end -->
                <!-- 公司详情介绍 -->
                <div class="gsdetails_box row">
                    <div class="gsdetails_box_l column">
                        <div class="gsdetails_box_l_top">
                            <div class="gsdetails_box_l_top_m_gongsijianjie column">
                                <!-- <img src="@/assets/images/gongsijianjie.png" alt="" style="width: 100%;"> -->
                                <div class="gsdetails_box_l_top_m_title">
                                    公司简介
                                </div>
                                <div class="gsdetails_box_l_top_m_gongsijianjie_main">
                                    京东于2004年正式涉足电商领域，2018年，京东集团市场交易额接近1.7万亿元*。2019年7月，京东第四次入榜《财富》全球500强，位列第139位，在全球仅次于亚马逊和Alphabet，位列互联网企业第三。<br /><br />2014年5月，京东集团在美国纳斯达克证券交易所正式挂牌上市，是中国第一个成功赴美上市的大型综合型电商平台。2015年7月，京东凭借高成长性入选纳斯达克100指数和纳斯达克100平均加权指数。
                                </div>
                            </div>
                            <div class="gsdetails_box_l_top_m_gongsixinxi column">
                                <!-- <img src="@/assets/images/gongsixinxi.png" alt="" style="width: 100%;"> -->
                                <div class="gsdetails_box_l_top_m_title">
                                    公司信息
                                </div>
                                <div class="gsdetails_box_l_top_m_gongsixinxi_main column">
                                    <div class="gsdetails_box_l_top_m_gongsixinxi_main_m row">
                                        <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_l column">
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_top">企业名称：</div>
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_bottom">
                                                北京京东尚科信息技术有限公司
                                            </div>
                                        </div>
                                        <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_c column">
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_top">法定代表人：</div>
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_bottom">
                                                辛波
                                            </div>
                                        </div>
                                        <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_r column">
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_top">成立时间：</div>
                                            <div class="gsdetails_box_l_top_m_gongsixinxi_main_m_bottom">
                                                2012-03-13
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="gsdetails_box_l_job">
                            <div class="gsdetails_box_l_job_m">
                                <img src="@/assets/images/gongsixiangqingrezhaozhiwei.png" alt="" style="width: 100%;">
                            </div>
                        </div>
                        <div class="gsdetails_box_l_bottom">
                            <div class="gsdetails_box_l_bottom_m">
                                <img src="@/assets/images/gongsixiangqingdibu.png" alt="" style="width: 100%;">
                            </div>
                        </div>
                    </div>
                    <div class="gsdetails_box_r column">
                        <div class="gsdetails_box_r_time column">
                            <div class="gsdetails_box_r_time_top">
                                <img src="@/assets/images/gongsuoshijianjifuli.png" alt="" style="width: 100%;">
                            </div>
                            <div class="gsdetails_box_r_time_main column">
                                <img src="@/assets/images/gongzuoshijianjifulineirong.png" alt="" style="width: 100%;">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 公司详情介绍 end -->
            </div>
            <div v-if="gongsitabs == 2">
                <!-- 公司职位类型 -->
                <div class="gsdetails_position_state">
                    <div class="gsdetails_position_state_m column">
                        <img src="@/assets/images/gongsixiangqingzhiweileixing.png" alt="" style="width: 100%;">
                    </div>
                </div>
                <!-- 公司职位类型 end -->
                <!-- 公司职位详情 -->
                <div class="gsdetails_job row">
                    <div class="gsdetails_job_l">
                        <div class="gsdetails_job_l_list" v-for="(item, index) in 5" :key="index">
                            <div class="gsdetails_job_l_list_top">
                                <img src="@/assets/images/gongsixiangqingzhiweidingbu.png" alt="" style="width: 100%;">
                            </div>
                            <div class="gsdetails_job_l_list_bottom">
                                <img src="@/assets/images/gongsixiangqingzhiweidibu.png" alt="" style="width: 100%;">
                            </div>
                        </div>
                        <div class="gsdetails_job_l_fenye">
                            <img src="@/assets/images/fenye.png" alt="">
                        </div>
                    </div>
                    <div class="gsdetails_job_r column">
                        <div class="gsdetails_job_r_top">
                            <img src="@/assets/images/gongsixiangqingzhiweimingcheng.png" alt="" style="width: 100%;">
                        </div>
                        <div class="gsdetails_job_r_main">
                            <img src="@/assets/images/gongsixiangqingzhiweijianjiexiangqing.png" alt=""
                                style="width: 100%;">
                        </div>
                    </div>
                </div>
                <!-- 公司职位详情 end -->
                <!-- 精选职位 -->
                <div class="gsdetails_jingxuanzhiwei column">
                    <img src="@/assets/images/gongsixiangqingzhiweijingxuanzhiwei.png" alt="" style="width: 100%;">
                </div>
                <!-- 精选职位 end -->
                <!-- 推荐公司 -->
                <div class="gsdetails_tuijiangongsi">
                    <img src="@/assets/images/gongsixiangqingzhiweituijiangongsidibu.png" alt="" style="width: 100%;">
                </div>
                <!-- 推荐公司 end -->
            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaGongSiDetails',
    components: { NavTop, Footer },
    data() {
        return {
            gongsitabs: 1,
        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {
        // 点击tabs
        clickTabs(val) {
            this.gongsitabs = val;
        }
    }

}
</script>

<style scoped>
.gsdetails {
    width: 100%;
    height: auto;
}

.gsdetails_banner {
    width: 100%;
    height: auto;
    background-image: linear-gradient(90deg, #3b526a 0, #345a6d 100%);
    padding: 30px 0 16px 0;
    line-height: 0;
}

.gsdetails_banner_m {
    width: 1200px;
    height: auto;
    margin: auto;
}

.gsdetails_banner_m_top {
    justify-content: space-between;
}

.gsdetails_banner_m_top_l {}

.gsdetails_banner_m_top_l_l {
    width: 70px;
    height: 70px;
    border-radius: 12px;
}

.gsdetails_banner_m_top_l_r {
    margin-left: 24px;
}

.gsdetails_banner_m_top_l_r_top {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    line-height: 40px;
    padding: 0 0 3px 0;
}

.gsdetails_banner_m_top_l_r_bottom {
    padding: 0 0 0 2px;
    margin-top: 3px;
    margin-bottom: 0;
    font-size: 13px;
    font-weight: 400;
    color: #fff;
    line-height: 18px;
}

.gsdetails_banner_m_top_l_r_bottom_m {}

.gsdetails_banner_m_top_r {
    align-items: baseline;
}

.gsdetails_banner_m_top_r_weight {
    font-size: 46px;
    line-height: 55px;
    text-align: right;
    color: #fff;
    padding: 0;
    font-weight: 400;
    margin-right: 6px;
}

.gsdetails_banner_m_top_r_text {
    color: #fff;
    font-size: 15px;
    line-height: 21px;
}

.gsdetails_banner_m_bottom {
    justify-content: space-between;
    margin-top: 25px;
    align-items: center;
}

.gsdetails_banner_m_bottom_l {
    align-items: center;
}

.gsdetails_banner_m_bottom_l_m {
    margin-right: 8px;
    padding: 0 8px;
    display: inline-block;
    color: #fff;
    height: 21px;
    line-height: 21px;
    background: rgba(34, 34, 34, .2);
    border-radius: 4px;
    font-size: 12px;
}

.gsdetails_banner_m_bottom_r {
    align-items: center;
}

.gsdetails_banner_m_bottom_r_m {
    color: #00b277;
    margin-left: 20px;
    align-items: center;
}

.gsdetails_banner_m_bottom_r_m_i {
    font-size: 16px;
    line-height: 22px;
    margin-right: 10px;
}

.gsdetails_banner_m_bottom_r_m_text {
    font-size: 16px;
    line-height: 22px;
}

.gsdetails_top {
    width: 1150px;
    height: 50px;
    margin: 20px auto 0;
    background: #fff;
    border-radius: 10px;
    padding: 0 25px;
}

.gsdetails_top_tabs {
    padding: 12px 0;
    font-size: 18px;
    font-weight: 500;
    color: #333;
    line-height: 25px;
    transition: all .2s linear;
    margin-right: 30px;
    cursor: pointer;
    border-bottom: 2px solid #fff;
}

.gsdetails_top_tabs:hover {
    color: #00b277;
}

.gsdetails_top_tabs_border {
    color: #00b277;
    border-bottom: 2px solid #00b277;
}

.gsdetails_hotjob {
    width: 1200px;
    height: auto;
    margin: 20px auto 0;
    background: #fff;
    border-radius: 10px;
}

.gsdetails_hotjob_m {
    padding: 20px;
}

.gsdetails_box {
    width: 1200px;
    height: auto;
    margin: auto;
    margin-top: 20px;
    justify-content: space-between;
}

.gsdetails_box_l {
    width: 900px;
}

.gsdetails_box_l_top {
    width: 840px;
    height: auto;
    padding: 20px 30px;
    background: #fff;
    border-radius: 10px;
}

.gsdetails_box_l_top_m_gongsijianjie {
    width: 100%;
    height: auto;
}

.gsdetails_box_l_top_m_title {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    color: #222;
    line-height: 25px;
    margin-bottom: 12px;
}

.gsdetails_box_l_top_m_gongsijianjie_main {
    font-size: 15px;
    font-weight: 400;
    color: #333;
    line-height: 28px;
    /* max-height: 113px; */
    overflow: hidden;
}

.gsdetails_box_l_top_m_gongsixinxi {
    width: 100%;
    height: auto;
    margin-top: 36px;
}

.gsdetails_box_l_top_m_gongsixinxi_main {
    border-radius: 12px;
    background: #f8f8f8;
    padding: 20px;
    height: auto;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m {
    margin-bottom: 30px;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m_l {
    width: 420px;
    padding: 0 5px 0 0;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m_top {
    font-size: 14px;
    color: #999;
    line-height: 20px;
    margin-bottom: 8px;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m_bottom {
    font-size: 15px;
    color: #333;
    line-height: 21px;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m_c {
    width: 210px;
    padding: 0 5px 0 0;
}

.gsdetails_box_l_top_m_gongsixinxi_main_m_r {
    width: 150px;
    padding: 0 5px 0 0;
}


.gsdetails_box_l_job {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.gsdetails_box_l_job_m {
    padding: 20px 30px;
}

.gsdetails_box_l_bottom {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.gsdetails_box_l_bottom_m {
    padding: 20px;
}

.gsdetails_box_r {
    width: 280px;
    height: auto;
}

.gsdetails_box_r_time {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
}

.gsdetails_box_r_time_main {
    padding: 20px;
}

.gsdetails_position_state {
    width: 1200px;
    height: auto;
    margin: 20px auto 0;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
}

.gsdetails_position_state_m {
    padding: 20px;
}

.gsdetails_job {
    width: 1200px;
    height: auto;
    margin: 20px auto 0;
    justify-content: space-between;
}

.gsdetails_job_l {
    width: 380px;
    height: auto;
}

.gsdetails_job_l_list {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 15px;
}

.gsdetails_job_l_list:hover {
    z-index: 2;
    box-shadow: 0 20px 16px 0 hsla(0, 0%, 70.2%, .2);
}

.gsdetails_job_l_list_top {
    padding: 20px 20px 10px;
}

.gsdetails_job_l_list_bottom {
    width: 100%;
    height: auto;
}

.gsdetails_job_l_fenye {
    width: 100%;
    height: auto;
    text-align: center;
}

.gsdetails_job_r {
    width: 740px;
    height: auto;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding: 20px 30px;
}

.gsdetails_job_r_top {
    width: 100%;
    height: auto;
}

.gsdetails_job_r_main {
    width: 100%;
    height: auto;
    margin-top: 20px;
}

.gsdetails_jingxuanzhiwei {
    width: 1160px;
    height: auto;
    margin: 20px auto 0;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding: 20px;
}

.gsdetails_tuijiangongsi {
    width: 1160px;
    height: auto;
    margin: 20px auto 0;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding: 20px;
}
</style>
